import * as types from "../../../_constants/types";

export default (state = "EN", action) => {
    switch (action.type) {
        case types.LANGUAGE_LOAD:
            return action.results;

        case types.RESET:
        case types.LANGUAGE_RESET:
            return "EN";

        default:
            return state;
    }
};
